
interface FooterProps {
  scrollToSection: (id: string) => void;
}

export default function Footer({ scrollToSection }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/aea82ce1bdb1715498721ef3bf0e643f/67a9b1b6c1a42d2e7b2b9cf2cd23bb63.jpeg" 
                alt="Simple Amenities Logo" 
                className="h-12 w-12 object-contain"
              />
              <h3 className="text-3xl font-bold">SIMPLE AMENITIES</h3>
            </div>
            <p className="text-gray-400 leading-relaxed mb-8 max-w-xs">
              AI-powered vending solutions for modern businesses across New Jersey
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/profile.php?id=61588557862981" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/simpleamenitiess/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div>
            <div className="space-y-8">
              <div>
                <h4 className="text-xs uppercase tracking-wider text-gray-500 mb-2">LOCATION</h4>
                <p className="text-white">Matawan New Jersey</p>
              </div>
              <div>
                <h4 className="text-xs uppercase tracking-wider text-gray-500 mb-2">PHONE</h4>
                <a href="tel:+15551234567" className="text-white hover:text-teal-500 transition-colors cursor-pointer">
                  (908) 902-1076
                </a>
              </div>
              <div>
                <h4 className="text-xs uppercase tracking-wider text-gray-500 mb-2">EMAIL</h4>
                <a href="mailto:simpleamenitiesllc@gmail.com" className="text-white hover:text-teal-500 transition-colors cursor-pointer">
                  simpleamenitiesllc@gmail.com
                </a>
              </div>
              <div>
                <h4 className="text-xs uppercase tracking-wider text-gray-500 mb-2">WEBSITE</h4>
                <a href="https://joesamenities.com/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-teal-500 transition-colors cursor-pointer">
                  joesamenities.com
                </a>
              </div>
            </div>
          </div>

          {/* Visual Column */}
          <div>
            <img 
              src="https://static.readdy.ai/image/aea82ce1bdb1715498721ef3bf0e643f/f925e81015937a9017b9b3bd4b0e6272.jpeg"
              alt="AI Vending Machine Detail"
              className="w-full h-96 object-cover rounded-xl"
            />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2025 Simple Amenities. All rights reserved.
            </p>
            <div className="flex gap-6">
              <button onClick={() => scrollToSection('home')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </button>
              <button onClick={() => scrollToSection('home')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Terms
              </button>
              <button onClick={() => scrollToSection('home')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Sitemap
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}